// extracted by mini-css-extract-plugin
module.exports = {"paper":"Menu_paper__1Zbv-","buttonsWrap":"Menu_buttonsWrap__3AYjz"};